import { render, staticRenderFns } from "./LeadsOverviewV1.vue?vue&type=template&id=3b0ab12c&scoped=true&lang=pug"
import script from "./LeadsOverviewV1.vue?vue&type=script&lang=js"
export * from "./LeadsOverviewV1.vue?vue&type=script&lang=js"
import style0 from "./LeadsOverviewV1.vue?vue&type=style&index=0&id=3b0ab12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ab12c",
  null
  
)

export default component.exports